// extracted by mini-css-extract-plugin
export var cardHeader = "_gv-1";
export var contentCard = "_gv-0";
export var headerActions = "_gv-3";
export var reorderHandle = "_gv-5";
export var titleArea = "_gv-2";
export var titleAreaWithHandle = "_gv-4";